/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { loadUserProfile } from "Core/actions";

import { Subscription } from "../components/Subscription/Subscription";
import Spinner from '../components/layouts/Spinner';

function ProfileSubscription(props) {
  useEffect(() => {
    document.getElementById("main_wrapper").style.background = "#fcfcfc";
    props.loadUserProfile();
  }, []);

  const { subscription, loading } = props;

  if (loading) {
    return <Spinner className="py-5" />;
  }

  return (
    <Content>
      <SectionTitle>Управление подпиской</SectionTitle>
      <Subscription
        data={subscription}
        loadUserProfile={props.loadUserProfile}
      />
    </Content>
  );
}

const mapStateToProps = (state) => {
  const props = state.local.userProfileReducer;
  return props;
};

const ProfileSubscriptionConnected = connect(mapStateToProps, {
  loadUserProfile,
})(ProfileSubscription);

export default ProfileSubscriptionConnected;

const Content = styled.div`
    margin: 20px 0;
`;

const SectionTitle = styled.h5`
  margin: 0;
  text-align: center;
  font: 22px/1 Roboto;
`;
